import { PodcastDetailInfo } from "./PodcastDetailInfo";

export default PodcastDetailInfo;
